module.exports = __webpack_public_path__ + "static/media/HSBC.04b0d86c.png";